import React, { Component } from 'react';

import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import Navbar from '../../components/navBar/navBar';
import {
  verifyLogin,
  apiList,
  shortDate,
} from '../../helpers';
import BasicDetails from './BasicDetails';
import Access from './Access';
import ChangePassword from './ChangePassword';
import Roles from './Roles';
import '../../assets/style/profile.scss';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// createdAt is stored as "DD-MM-YYYY HH:mm:ss" (older rows may be ISO).
const formatDate = (value) => {
  if (!value) return null;
  let match = /^(\d{2})-(\d{2})-(\d{4})/.exec(value);
  if (match) return `${Number(match[1])} ${MONTHS[Number(match[2]) - 1]} ${match[3]}`;
  match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (match) return `${Number(match[3])} ${MONTHS[Number(match[2]) - 1]} ${match[1]}`;
  return shortDate(value);
};

const initials = (firstName, lastName) => `${(firstName || '').trim().charAt(0)}${(lastName || '').trim().charAt(0)}`.toUpperCase() || '?';

class Profile extends Component {
  constructor() {
    super();
    this.state = {
      userDetails: null,
      rolePermissions: [],
      accessLevel: [],
    };
  }

  componentDidMount() {
    this.getUserDetails();
    this.getRoles();
    this.getPermissionConfig();
  }

  getUserDetails() {
    const { session, user } = verifyLogin();
    const config = { headers: { session } };
    axios.get(`${apiList.GET_USER_DETAILS}?id=${user.id}`, config)
      .then((response) => {
        this.setState({ userDetails: response.data.data });
      })
      .catch(() => {
      });
  }

  getRoles() {
    const { session, user } = verifyLogin();
    const config = { headers: { session } };
    axios.get(`${apiList.GET_PERMISSION_CONFIG_BY_ROLEID}?id=${user.userRoleId}`, config)
      .then((response) => {
        this.setState({ rolePermissions: [...response.data.data.paginate] });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getPermissionConfig() {
    const { session, user } = verifyLogin();
    const config = { headers: { session } };
    axios.get(`${apiList.GET_ACCESS_LEVEL_BY_USERID}?subscriberId=${user.id}`, config)
      .then((response) => {
        const data = response.data.data.paginate;
        this.setState({ accessLevel: [...data] });
      })
      .catch(() => {
      });
  }

  renderSummary() {
    const { userDetails } = this.state;
    // Until details load, show the name saved at sign-in.
    const person = userDetails || (verifyLogin() || {}).user || {};
    const tags = [
      userDetails?.UserRole?.role,
      userDetails?.UserProduct?.productName,
      userDetails?.Subscribers?.subscriberName,
    ].filter(Boolean);
    const memberSince = formatDate(userDetails?.createdAt);

    return (
      <section className='profile-card profile-summary'>
        <span className='avatar' aria-hidden='true'>{initials(person.firstName, person.lastName)}</span>
        <div className='summary-text'>
          <h2>{`${person.firstName || ''} ${person.lastName || ''}`.trim() || 'Your profile'}</h2>
          <p className='summary-email'>{person.email || ''}</p>
          {tags.length ? (
            <div className='summary-tags'>
              {tags.map((tag) => <span key={tag}>{tag}</span>)}
            </div>
          ) : null}
        </div>
        {userDetails ? (
          <dl className='summary-meta'>
            <dt>Member since</dt>
            <dd>{memberSince || '—'}</dd>
            <dt>Mobile</dt>
            <dd>{userDetails.alternateNumber || '—'}</dd>
          </dl>
        ) : null}
      </section>
    );
  }

  render() {
    const { userDetails, rolePermissions, accessLevel } = this.state;
    return (
      <div className='profile-page'>
        {/* Toasts render in the app-wide container (NetworkDetector). */}
        <Navbar MainProps={this.props} />

        <main className='profile-main'>
          <div className='profile-heading'>
            <h1>Profile</h1>
            <p>Manage your details and password, and review what your account can access.</p>
          </div>

          {this.renderSummary()}

          <div className='profile-grid'>
            {userDetails ? (
              <BasicDetails
                userDetails={userDetails}
                onSaved={(saved) => this.setState({ userDetails: { ...userDetails, ...saved } })}
              />
            ) : (
              <section className='profile-card profile-loading'>
                <CircularProgress size={28} />
              </section>
            )}
            <ChangePassword />
          </div>

          <Roles rolePermissions={rolePermissions} roleName={userDetails?.UserRole?.role} />
          <Access data={accessLevel} />
        </main>
      </div>
    );
  }
}
export default Profile;
